<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>거래처 등록</strong></div>
			<h2 class="h_sub">거래처 등록</h2>
		</div>

    <MerchantManageCreateForm/>
  </div>
</template>

<script>
import MerchantManageCreateForm from '@/components/admin/merchant/MerchantManageCreateForm.vue';

export default {
  components: {
    MerchantManageCreateForm
  }
}
</script>
<style lang="">
    
</style>